export const sumValues = (items: number[]): number =>
  items.reduce((firstValue, secondValue) => firstValue + secondValue, 0);

export const roundTo2DecimalPlaces = (num: number): number => Math.round((num + Number.EPSILON) * 100) / 100;
